export default __webpack_public_path__ + "8c4996ad662f5348c62de148a9f4c328.png";